export async function create({ domain }) {
  const response = await this.post('/external_apps/tokens', { domain });

  return response;
}
